import { useEffect } from "react";
import { useNavigate } from "@tanstack/react-router";
import { isNativeApp } from "@/lib/native-app";
import { configureNativeChrome, installNativeBackHandler } from "@/lib/native-runtime";
import { installPushTapHandler } from "@/lib/native-push";
import { installReminderTapHandler } from "@/lib/native-reminders";
import { NativeCommerceGuard } from "./NativeCommerceGuard";
import { AppleIapSync } from "./AppleIapSync";
import { NativeTabBar } from "./NativeTabBar";
import { JournalNativeTabBar } from "./JournalNativeTabBar";
import { NativeOnboarding } from "./NativeOnboarding";
import { NativePullToRefresh } from "./NativePullToRefresh";
import { useIsJournalNativeApp, useIsNativeApp } from "@/lib/native-app";

/**
 * Everything the native iOS app adds around the existing website.
 * On the web this renders nothing at all.
 */
export function NativeShell() {
  const native = useIsNativeApp();
  const journalApp = useIsJournalNativeApp();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isNativeApp()) return;
    document.documentElement.setAttribute("data-native-app", "true");
    void configureNativeChrome();
    void installPushTapHandler((path) => navigate({ to: path }));
    void installReminderTapHandler((path) => navigate({ to: path }));
    let cleanup: (() => void) | undefined;
    void installNativeBackHandler(() => {
      if (window.history.length > 1) {
        window.history.back();
        return true;
      }
      return false;
    }).then((fn) => {
      cleanup = fn;
    });
    return () => cleanup?.();
  }, [navigate]);

  return (
    <>
      <NativeCommerceGuard />
      {native ? <AppleIapSync /> : null}
      {native ? (
        <>
          <NativePullToRefresh />
          {journalApp ? <JournalNativeTabBar /> : <NativeTabBar />}
          <NativeOnboarding />
        </>
      ) : null}
    </>
  );
}
